import React from "react";
import { API_URL } from "../../constants/api";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { SECTIONS } from "../../constants/appConstants";
import {
  IsSectionVisible,
  decimalNumberWithCommas,
  PaperComponent,
  getColorClass,
  GetEnableProperty,
  GetPropertyVisibility
} from "../../utils/helper";
import {
  apiBatchRequest,
  apiDelete,
  apiRequest
} from "../../utils/api_service";
import {
  AppBar,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Toolbar,
  Tooltip,
  Typography
} from "@material-ui/core";
import "./tenants.less";
import { Tenant_List } from "../../constants/ssrs_api";
import commonLabels from "../../constants/messageConstants";
import ConfirmDialog from "../common/Dailogbox/ConfirmDailog";
import AddUpdateTenant from "./addUpdateTenant";
import { NavLink, withRouter } from "react-router-dom";
import { uniqBy } from "lodash/array";
import { sortBy } from "lodash/collection";
import { convertIntoDDFormat, getSearchedProperty } from "../../utils/generic";
import { ShowToast, toastType } from "../../utils/toast-service";
import PaginationControlled from "../common/pagination/pagination";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { convertAPIDateInStdFormat, getDiffInDays } from "../../utils/date";
import TableHeaderWithFilter from "../common/table-header-filter";
import { getArrayIndex, getArrayObject } from "../../utils/lodash";
import { filterTableRows } from "../../utils/filtered";
import DownloadSSRSPopUp from "../common/button-download-popup";
import { downloadExcelReportByAPI } from "../../utils/downloading";
import moment from "moment";
import FilterOff from "../../public/img/common/filterOff.svg";
import RefreshIcon from "@material-ui/icons/Refresh";
import { routes } from "../../constants/routes";

class TenantsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tenantList: [],
      isOpenDeleteConfirmationPanel: false,
      isUpdateDialogOpen: false,
      searchTenantText: "",
      filteredSites: [],
      isShowInactive: false,
      siteFilterList: [],
      pageNo: 0,
      rowsPerPagination: 25,
      usersCount: 0,
      viewAllSuite: false,
      selectedServiceLocations: "",
      colFilteredObj: props.history.location.appState?.colFilteredObj || [],
      sortByColKey: "",
      dcMasterData: [],
      isShowColFilter: true,
      reload: false,
      selectedSource: [],
      selectedIds: props.history.location.appState?.selectedIds || {},
      refreshFilteredObj: false,
      clearData: false,
      keepFilterData: false,
      toolTipData: []
    };
  }

  
  /**
   * fetch list data
   */
  componentDidMount() {
    const props= this.props;
    const data = props.history.location.appState?.colFilteredObj;
    const sel = props.history.location.appState?.selectedIds;
    this.getTenantList(true, data, sel);
    this.getMasterData();
    if (data == undefined && sel == undefined) {
      localStorage.removeItem("selectedIds");
      localStorage.removeItem("colObj");
    }
  }

  componentWillReceiveProps(newProps) {
    const props= this.props;
    if (
      newProps.isTenantSaved &&
      newProps.isTenantSaved != props.isTenantSaved
    ) {
      this.getTenantList(false);
    }
  }

  /**
   * call on refresh tenant list
   */
  resetPage = () => {
    const props=this.props;
    const data = props.history.location.appState?.colFilteredObj;
    const sel = props.history.location.appState?.selectedIds;
    this.getTenantList(true, data, sel);
  };

  /**
   * get the master data list of datacenter and tooltip
   */
  getMasterData = () => {
    apiBatchRequest([
      {
        url: API_URL.datacenter.getDatacenterList,
        key: "dcMasterData"
      },
      {
        url: API_URL.masterData.GetLabels,
        params: { sectionId: SECTIONS.ADD_UPDATE_TENANT },
        key: "toolTipData"
      }
    ]).then(({ dcMasterData, toolTipData }) => {
      dcMasterData.data = GetEnableProperty((dcMasterData?.data || []), SECTIONS.TENANT_LIST );
      this.setState({
        actualDcMasterData: dcMasterData.data || [],
        dcMasterData: convertIntoDDFormat(
          dcMasterData.data || [],
          "name",
          "name"
        ),
        toolTipData: toolTipData.data || []
      });
    });
  };

  /**
   * call on delete confirmation panel
   * @param {*} tenantId 
   */
  openDeleteConfirmationPanel = tenantId => {
    this.setState({ isOpenDeleteConfirmationPanel: true, tenantId: tenantId });
  };

  /**
   * call on delete confirmation panel
   */
  closeDeleteConfirmationPanel = () => {
    this.setState({ isOpenDeleteConfirmationPanel: false, tenantId: 0 });
  };

  /**
   * call on view all saved suit on popup
   * @param {*} viewAllSuite 
   * @param {*} serviceLocations 
   */
  handleViewSuite = (viewAllSuite = false, serviceLocations) => {
    this.setState({
      viewAllSuite: viewAllSuite,
      selectedServiceLocations: serviceLocations
    });
  };

  /**
   * call on delete popup 
   * @param {*} res 
   */
  deleteTenant = res => {
    const {tenantId} = this.state;
    if (res == true) {
      apiDelete({
        url: API_URL.tenant.DeleteTenant + "?tenantId=" + tenantId
      }).then(response => {
        response.success == false
          ? ShowToast(
              "Server Error: Unable to delete Tenant.",
              toastType.ERROR,
              5000,
              500
            )
          : ShowToast(
              "Tenant has been deleted successfully.",
              toastType.SUCCESS,
              5000,
              200
            );
        this.setState({ isOpenDeleteConfirmationPanel: false }, () => {
          this.getTenantList(false);
        });
      });
    } else {
      this.setState({ isOpenDeleteConfirmationPanel: false });
    }
  };

  /**
   * get tenant lists
   * @param {*} isAllIds 
   * @param {*} data 
   * @param {*} sel 
   */
  getTenantList = (isAllIds = true, data = null, sel = null) => {
    apiRequest({
      url: API_URL.tenant.GetTenants
    }).then(({ data: List }) => {
      const siteList = [
        ...sortBy(
          uniqBy(convertIntoDDFormat(List || [], "Site", "Site"), x => x.id),
          [
            function(o) {
              return o.value;
            }
          ]
        )
      ];

      const allIds = siteList.map(function(item) {
        return item.id;
      });
      allIds.push("All");
      const {filteredSites, reload, colFilteredObj} = this.state;

      this.setState({
        tenantList: List,
        siteFilterList: siteList || [],
        filteredSites: isAllIds ? allIds : filteredSites,
        sortByColKey: "",
        keepFilterData: true,
        reload: !reload,
        selectedSource: colFilteredObj,
        clearData: false
      });
      data && sel && this.initializeFilter(data, sel);
    });
  };

  /**
   * initialize filter
   * @param {*} data 
   * @param {*} sel 
   */
  initializeFilter = (data, sel) => {
    if (data && sel) {
      const {reload} = this.state;
      this.setState(
        {
          colFilteredObj: data,
          selectedIds: sel,
          reload: !reload,
          keepFilterData: true,
          selectedSource: data
        },
        () => {
          this.forceUpdate();
        }
      );
    }
  };

  /**
   * open update dialog
   * @param {*} isOpen 
   * @param {*} usersCount 
   */
  openUpdateDialog = (isOpen = true, usersCount = 0) => {
    this.setState({ isUpdateDialogOpen: isOpen });
    this.setState({ usersCount: usersCount });
  };

  /**
   * set state value
   * @param {*} id 
   * @param {*} value 
   */
  setStateValue = (id, value) => {
    this.setState({ [id]: value });
  };

  /**
   * call on multi select dropdown
   * @param {*} ids 
   */
  onMultiSelectDD = (ids = []) => {
    this.selectDataCenterValues(ids);
  };

  /**
   * call on multiple select dropdown
   * @param {*} ids 
   */
  selectDataCenterValues(ids = []) {
    const { filteredSites, siteFilterList } = this.state;
    if (ids.indexOf("All") !== -1) {
      const allIds = siteFilterList.map(function(item) {
        return item.id;
      });
      const filteredIds = ids.filter(f => f != "All");

      if (
        filteredIds.length == allIds.length ||
        (ids.length > 0 && ids[0] == "All") ||
        (filteredSites.indexOf("All") == -1 && ids.indexOf("All") !== -1)
      ) {
        allIds.push("All");
        this.setState({ filteredSites: allIds, pageNo: 0 });
      } else {
        this.setState({ filteredSites: filteredIds, pageNo: 0 });
      }
    } else {
      if (filteredSites.indexOf("All") !== -1) {
        this.setState({ filteredSites: [], pageNo: 0 });
      } else {
        const allIds = siteFilterList.map(function(item) {
          return item.id;
        });
        const idsWithoutAll = ids.filter(f => f != "All");
        if (idsWithoutAll.length == allIds.length) {
          allIds.push("All");
          this.setState({ filteredSites: allIds, pageNo: 0 });
        } else {
          this.setState({ filteredSites: ids, pageNo: 0 });
        }
      }
    }
  }

  /**
   * call on refresh tenant list
   * @param {*} isTenantSaved 
   */
  refreshTenants = (isTenantSaved = false) => {
    const {reload, colFilteredObj} = this.state;

    this.setState({
      keepFilterData: true,
      reload: !reload,
      selectedSource: colFilteredObj,
      clearData: false
    });
    if (isTenantSaved) {
      this.getTenantList(false);
    }
    this.openUpdateDialog(false);
  };

  /**
   * call on clear filter
   */
  clearFilter = () => {
    localStorage.removeItem("selectedIds");
    localStorage.removeItem("colObj");
    const {refreshFilteredObj} = this.state;

    this.setState({
      colFilteredObj: [],
      clearData: true,
      refreshFilteredObj: !refreshFilteredObj,
      selectedIds: {}
    });
  };

  /**
   * get all filter list
   * @param {*} listData 
   * @returns 
   */
  getFilterList = listData => {
    const {
      searchTenantText,
      isShowInactive,
      colFilteredObj,
      sortByColKey
    } = this.state;
    const searchList = getSearchedProperty(
      listData,
      searchTenantText,
      "TenantName"
    );

    const year = new Date().getFullYear();
    const day = new Date().getDate();
    const month = new Date().getMonth();
    let activeList = searchList;
    if (!isShowInactive) {
      activeList =
        activeList?.filter(
          f =>
            f.EffectiveTo == null ||
            (f.EffectiveTo &&
              new Date(
                new Date(f.EffectiveTo).getFullYear(),
                new Date(f.EffectiveTo).getMonth(),
                new Date(f.EffectiveTo).getDate()
              ) >= new Date(year, month, day))
        ) || [];
    }

    const fData = sortBy(
      filterTableRows(activeList, colFilteredObj),
      x => x[sortByColKey]
    );

    return fData || [];
  };

  /**
   * update page count call on pagination
   * @param {*} pageNo 
   * @param {*} rowsPerPagination 
   */
  updateRowCount = (pageNo, rowsPerPagination) => {
    this.setState({ pageNo, rowsPerPagination });
  };

  /**
   * update the selected filters
   * @param {*} key 
   * @param {*} value 
   * @param {*} filterType 
   */
  updateColumnFilter = (key, value = "", filterType) => {
    const { colFilteredObj, selectedIds } = this.state;
    const index = getArrayIndex(colFilteredObj, { keyName: key });
    if (index !== -1) {
      colFilteredObj[index] = {
        keyName: key,
        value,
        filterType: filterType || "string"
      };
      key &&
        this.setState({
          colFilteredObj: colFilteredObj,
          selectedIds: { ...selectedIds, [key]: value },
          clearData: false,
          pageNo: 0
        });
      colFilteredObj.length > 0 &&
        localStorage.setItem("colObj", JSON.stringify(colFilteredObj));
    } else {
      key &&
        this.setState({
          colFilteredObj: [
            ...colFilteredObj,
            { keyName: key, value, filterType: filterType || "string" }
          ],
          selectedIds: { ...selectedIds, [key]: value },
          clearData: false,
          pageNo: 0
        });
      value &&
        localStorage.setItem(
          "colObj",
          JSON.stringify([
            ...colFilteredObj,
            { keyName: key, value, filterType: filterType || "string" }
          ])
        );
    }

    //colFilteredObj.length > 0 &&
    value &&
      localStorage.setItem(
        "selectedIds",
        JSON.stringify({ ...selectedIds, [key]: value })
      );
  };

  /**
   * call on ssrs pdf/excel download
   * @param {*} report 
   * @param {*} type 
   */
  downloadSSRSReport = (report, type = "excel") => {
    const {
      colFilteredObj,
      actualDcMasterData = [],
      isShowInactive
    } = this.state;
    const siteList =
      colFilteredObj.filter(f => f.keyName == "Site")[0]?.value.toString() ||
      "All";
    let siteIds = "";

    if (siteList && siteList.length > 0) {
      siteList.split(",").map(function(r) {
        if (r != "All") {
          siteIds +=
            actualDcMasterData.filter(f => f.name == r)[0]?.propertyID + ",";
        } else siteIds = "All,";
      });
      if (siteIds.slice(-1) == ",") {
        siteIds = siteIds.slice(0, -1);
      }
    }
    const dateFilter = colFilteredObj.filter(f => f.keyName == "EffectiveTo")[0]
      ?.value;
    let fromDate = "IsNull=True";
    let toDate = "IsNull=True";
    if (dateFilter && dateFilter.length > 0) {
      [fromDate, toDate] = dateFilter.split("-");
    }
    const param = `&TenantStatus=${
      isShowInactive ? "Inactive" : "Active"
    }&StartDate:IsNull=True&EndDate:IsNull=True&DataCenter=${siteIds}&TenantName=${getValueFrom(
      "TenantName"
    )}&PowerLeasedKW=${getValueFrom("PowerLeased")}&SqFtLeased=${getValueFrom(
      "SqFt"
    )}&ServiceLocations=${getValueFrom("ServiceLocations")}&FromDate${
      fromDate == "IsNull=True" ? ":" + fromDate : "=" + fromDate
    }&ToDate${
      toDate == "IsNull=True" ? ":" + toDate : "=" + toDate
    }&DateOffset=${moment().utcOffset()}`;
    switch (type) {
      case "pdf":
        downloadExcelReportByAPI(
          `${report.downloadLink}PDF${param}`,
          report.label,
          "application/pdf"
        );
        break;
      case "excel":
        downloadExcelReportByAPI(
          `${report.downloadLink}EXCELOPENXML${param}`,
          report.label
        );
        break;
    }

    function getValueFrom(keyVal, defaultVal = "All") {
      const obj = getArrayObject(colFilteredObj, { keyName: keyVal });
      return obj && obj.value ? obj.value : defaultVal;
    }
  };

  
  render() {
    const {
      isShowInactive,
      tenantList,
      isUpdateDialogOpen,
      usersCount,
      dcMasterData,
      colFilteredObj,
      isShowColFilter,
      toolTipData,
      refreshFilteredObj,
      tenantId,
      clearData,
      reload,
      selectedIds,
      selectedSource,
      keepFilterData,
      pageNo,
      rowsPerPagination,
      isOpenDeleteConfirmationPanel,
      selectedServiceLocations,
      viewAllSuite
    } = this.state;

    const TenantListing = IsSectionVisible(
      SECTIONS.TENANT,
      SECTIONS.TENANT_LIST
    );

    const filterList = isShowColFilter
      ? this.getFilterList(tenantList)
      : tenantList;

      const props = this.props;
    return (
      <div className={"col-xs-12 tenantTable"}>
        {isUpdateDialogOpen && (
          <AddUpdateTenant
            isOpen={isUpdateDialogOpen || false}
            onClose={this.openUpdateDialog}
            onSave={this.refreshTenants}
            tenantId={tenantId}
            usersCount={usersCount}
            toolTipData={toolTipData}
          />
        )}
        <div className={"row"}>
          <div className={"col-xs-10"} style={{ display: "flex" }}>
            {!props.isTenant && (
              <Button
                style={{ height: "30px" }}
                variant={"contained"}
                size={"small"}
                onClick={props.openAddDialog}
              >
                {"Add Tenant\r"}
              </Button>
            )}
            <FormControlLabel
              style={{ marginLeft: "0.5rem" }}
              className={"checkbox-filter"}
              control={
                <Checkbox
                  id={"IsAccessible"}
                  color={"primary"}
                  defaultValue={isShowInactive}
                  checked={isShowInactive}
                  onChange={event =>
                    this.setState({
                      isShowInactive: event.target.checked,
                      pageNo: 0
                    })}
                />
              }
              label={"Include Inactive"}
            />
            <FormControlLabel
              className={"show-filter"}
              control={
                <Checkbox
                  id={"filterCompletedOrCancelled"}
                  color={"primary"}
                  defaultValue={isShowColFilter}
                  checked={isShowColFilter}
                  onChange={event => {
                    localStorage.removeItem("selectedIds");
                    localStorage.removeItem("colObj");
                    this.setState({
                      isShowColFilter: event.target.checked,
                      colFilteredObj: [],
                      clearData: true,
                      refreshFilteredObj: !refreshFilteredObj,
                      sortByColKey: "",
                      selectedIds: {}
                    });
                  }}
                />
              }
              label={"Show Filters"}
            />
            <DownloadSSRSPopUp
              buttonLabel={"Print"}
              dataTip={
                toolTipData?.find(
                  b => b.UiColumnName == "Download"
                )?.Tooltip
              }
              reportList={[
                {
                  label: "Tenant List",
                  id: 1,
                  pdfDownload: true,
                  excelDownload: true,
                  downloadLink: Tenant_List
                }
              ]}
              downloadBtnLabel={"Download"}
              downloadReport={this.downloadSSRSReport}
            />
            <Tooltip 
              title={
                toolTipData?.find(
                  b => b.UiColumnName == "Clear Filter"
                )?.Tooltip
              }
              placement={"bottom"}
            >
              <img
                className={"icons"}
                src={FilterOff}
                alt={"logo"}
                onClick={() => {
                  this.clearFilter();
                }}
              />
            </Tooltip>
          </div>
          <div className={"col-xs-2 end-xs"}>
            <Tooltip 
              title={
                toolTipData?.find(
                b => b.UiColumnName == "Refresh"
               )?.Tooltip
              }
              placement={"bottom"}
            >
              <IconButton size={"small"} onClick={() => this.resetPage()}>
                <RefreshIcon
                  style={{
                    fill: "#365E7E",
                    marginTop: "7px",
                    width: "28px",
                    height: "30px"
                  }}
                />
              </IconButton>
            </Tooltip>
          </div>
        </div>
        <div className={"tenant-list-table-div"}>
          {TenantListing ? (
            <table
              className={"tenant-list-table"}
              style={{ fontWeight: "200 !important" }}
            >
              <thead>
                <tr
                  className={"blue-cust-title"}
                  style={{ borderTop: "3px solid #FFFFFF" }}
                >
                  <th
                    colSpan={8}
                    style={{
                      fontSize: "15px",
                      textAlign: "center",
                      lineHeight: "25px"
                    }}
                  >
                    {"Tenants\r"}
                  </th>
                </tr>
                <TableHeaderWithFilter
                  clearData={clearData}
                  refreshFilteredObj={refreshFilteredObj}
                  selectedId={selectedIds}
                  reload={reload}
                  keepFilterData={keepFilterData}
                  selectedSource={selectedSource}
                  columnData={[
                    {
                      headerClass: "w-15",
                      colName: "Data Center",
                      keyName: "Site",
                      filterType: "multiSelect",
                      selectedIds: colFilteredObj.Site,
                      optionsList: dcMasterData
                    },
                    {
                      headerClass: "w-15",
                      colName: "Tenant Name",
                      keyName: "TenantName"
                    },
                    {
                      headerClass: "w-10",
                      colName: "Power Leased kW",
                      keyName: "PowerLeased",
                      textAlign: "right"
                    },
                    {
                      headerClass: "w-10",
                      colName: "Sq Ft Leased",
                      keyName: "SqFt",
                      textAlign: "right"
                    },
                    {
                      headerClass: "w-20",
                      colName: "Service Locations",
                      keyName: "ServiceLocations"
                    },
                    {
                      headerClass: "w-15",
                      colName: "Effective To",
                      keyName: "EffectiveTo",
                      filterType: "dateRange",
                      toolTip:  toolTipData?.find(
                        b => b.UiColumnName == "Effective To Tenant"
                       )?.Tooltip || ""
                    },
                    {
                      headerClass: "w-10",
                      colName: "Action",
                      isHideFilter: true,
                      textAlign: "center"
                    },
                    {
                      headerClass: "w-10",
                      colName: "Contact Details",
                      isHideFilter: true,
                      textAlign: "center"
                    }
                  ]}
                  isShowFilter={isShowColFilter}
                  onChangeFilter={this.updateColumnFilter}
                />
              </thead>
              <tbody>
                {filterList && filterList.length > 0 ? (
                  (
                    (rowsPerPagination > 0
                      ? filterList.slice(
                          pageNo * rowsPerPagination,
                          pageNo * rowsPerPagination +
                            rowsPerPagination
                        )
                      : filterList) || []
                  ).map((item, index) => (
                    <tr key={"tenants" + index}>
                      <td>{item.Site == null ? "-" : item.Site}</td>
                      <td>{item.TenantName}</td>
                      <td style={{ textAlign: "right" }}>
                        {item.PowerLeased != null
                          ? decimalNumberWithCommas(
                              parseFloat(item.PowerLeased)
                            )
                          : "-"}{" "}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {item.SqFt == null ? "-" : item.SqFt.toLocaleString()}
                      </td>
                      <td style={{ paddingLeft: "15px" }}>
                        {item.ServiceLocations ? (
                          item.ServiceLocations &&
                          item.ServiceLocations.split(",").length <= 2 ? (
                            item.ServiceLocations.split(",")?.map(
                              (obj, index) => (
                                <Chip
                                  key={"chip" + index + "c"}
                                  label={obj}
                                  style={{
                                    margin: 1,
                                    fontSize: "0.7rem",
                                    height: "1.8rem"
                                  }}
                                />
                              )
                            )
                          ) : (
                            <>
                              {item.ServiceLocations.split(",")
                                .slice(0, 2)
                                ?.map((obj, index) => (
                                  <Chip
                                    key={"chip" + index + "c"}
                                    label={obj}
                                    style={{
                                      margin: 1,
                                      fontSize: "0.7rem",
                                      height: "1.8rem"
                                    }}
                                  />
                                ))}
                              <span
                                style={{
                                  cursor: "pointer",
                                  fontSize: "0.7rem"
                                }}
                                onClick={() =>
                                  this.handleViewSuite(
                                    true,
                                    item.ServiceLocations
                                  )}
                              >
                                {" ...View all"}
                              </span>
                            </>
                          )
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>
                        <span
                          className={`colorText ${getColorClass(
                            getDiffInDays(
                              new Date(),
                              item.EffectiveTo
                                ? new Date(item.EffectiveTo.split("T")[0])
                                : ""
                            )
                          )}`}
                        >
                          {item.EffectiveTo
                            ? convertAPIDateInStdFormat(item.EffectiveTo)
                            : "-"}
                        </span>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <Tooltip
                          title={
                            toolTipData?.find(
                              b => b.UiColumnName == "Edit"
                             )?.Tooltip
                          }
                          onClick={() => {
                            this.setState({ tenantId: item.TenantId });
                            this.openUpdateDialog(true, item.UsersCount);
                          }}
                        >
                          <IconButton size={"small"}>
                            <EditIcon size={"small"} />
                          </IconButton>
                        </Tooltip>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <Tooltip
                         title={
                          toolTipData?.find(
                            b => b.UiColumnName == "View Contact Details"
                           )?.Tooltip
                         }
                        >
                          <NavLink
                            to={{
                              pathname: "/tenantContact",
                              aboutProps: {
                                TenantId: item.TenantId,
                                TenantName: item.TenantName,
                                PropertyId: item.PropertyId,
                                isOpenDefaultAdd:
                                  item.UsersCount && item.UsersCount > 0
                                    ? false
                                    : ((GetPropertyVisibility(SECTIONS.ADD_UPDATE_TENANT) || []).find(dp=> dp === item.PropertyId) === undefined) ? true : false,
                                isActiveTenant:
                                  getDiffInDays(
                                    new Date(),
                                    item.EffectiveTo
                                      ? new Date(item.EffectiveTo)
                                      : ""
                                  ) >= 0 || item.EffectiveTo == null,
                                tenantEffectiveToDate: item.EffectiveTo
                              }
                            }}
                            exact
                          >
                            <IconButton size={"small"}>
                              <VisibilityIcon
                                //fontSize="inherit"
                                size={"small"}
                                style={{ cursor: "pointer" }}
                              />
                            </IconButton>
                          </NavLink>
                        </Tooltip>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td style={{ textAlign: "center" }} colSpan={9}>
                      {"No data available\r"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          ) : (
            <></>
          )}
        </div>
        {filterList && filterList.length > 0 && (
          <div className={"paginationContainer"}>
            <PaginationControlled
              tableLength={filterList.length}
              updateRowCount={this.updateRowCount}
              pageNo={pageNo}
              rowsPerPagination={rowsPerPagination}
            />
          </div>
        )}
        <ConfirmDialog
          IsOpen={isOpenDeleteConfirmationPanel}
          Message={commonLabels.deleteTenantConfirmation.message}
          OnHandelClick={this.deleteTenant}
        />

        <Dialog
          open={viewAllSuite || false}
          onClose={() => this.handleViewSuite(false, "")}
          PaperComponent={PaperComponent}
          fullWidth
        >
          <AppBar style={{ position: "relative", backgroundColor: "#064473" }}>
            <Toolbar>
              <Typography
                variant={"h6"}
                style={{ marginLeft: "10px", flex: "1" }}
              >
                {"Service Locations"}
              </Typography>
              <IconButton
                title={"Close"}
                edge={"start"}
                color={"inherit"}
                onClick={() => this.handleViewSuite(false, "")}
                aria-label={"close"}
              >
                <IoMdCloseCircleOutline />
              </IconButton>
            </Toolbar>
          </AppBar>
          <DialogContent>
            {selectedServiceLocations &&
              selectedServiceLocations
                .split(",")
                ?.map((obj, index) => (
                  <Chip
                    key={"chip" + index + "c"}
                    label={obj}
                    style={{ margin: 1, fontSize: "0.7rem", height: "1.8rem" }}
                  />
                ))}
          </DialogContent>
          <DialogActions>
            <Button
              color={"primary"}
              onClick={() => this.handleViewSuite(false, "")}
            >
              {"Close\r"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withRouter(TenantsTable);
